// extracted by mini-css-extract-plugin
module.exports = {"radio":"Form_radio___I4iz","checkbox":"Form_checkbox__PXFIX"};